module.exports = __webpack_public_path__ + "img/carStart.51b73baf.png";